import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();
httpRequest.errorHandler = (_statusCode, error) => error;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const countOf = (res: any): number =>
  Number(
    res?.count ??
      res?.data?.count ??
      res?.total ??
      (Array.isArray(res?.rows) ? res.rows.length : Array.isArray(res) ? res.length : 0),
  ) || 0;

const safe = async (p: Promise<unknown>): Promise<number> => {
  try {
    return countOf(await p);
  } catch {
    return 0;
  }
};

const orderCount = (type: string, orderStatus: string) =>
  httpRequest.post("/ord/order/count", { type, orderStatus });

const buyerReviewedCount = () =>
  httpRequest.post("/ord/order/list", {
    filter: {
      type: "",
      orderStatus: "REVIEWED",
      deliveryNoteStatus: "",
      businessId: "",
      startDate: "",
      endDate: "",
      invoiceStatus: "",
      paymentStatus: "",
      paymentTermCondition: "",
      excel: "false",
    },
    offset: { page: 1, limit: 1 },
  });

async function orderTotal(isBuyer: boolean): Promise<number> {
  if (isBuyer) return safe(buyerReviewedCount());
  const [sales, purchase] = await Promise.all([
    safe(orderCount("SALES", "REVIEWED")),
    safe(orderCount("PURCHASE", "REVIEWED")),
  ]);
  return sales + purchase;
}

export async function getModuleBadges(isBuyer: boolean): Promise<Record<string, number>> {
  const [network, order, invoice] = await Promise.all([
    safe(httpRequest.get("/biz/invitation/received/count")),
    orderTotal(isBuyer),
    safe(httpRequest.get(isBuyer ? "/inv/invoice/received" : "/inv/invoice/sent", { offset: { page: 1, limit: 1 }, filter: { status: "SENT" } })),
  ]);

  return {
    NETWORK: network,
    ORDER: order,
    INVOICE: invoice,
  };
}
